import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router-dom";

import "./charts/dashboard.css";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  tableLoading,
  checkPermission,
  customStyle,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import DatePicker from "react-datepicker";
import moment from "moment";

//pages & includes
import ReportSidebar from "./ReportSidebar";
//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";

// graphs
import {
  DonutWidget,
} from "./charts";
import RadialWidget from "./charts/RadialWidget";
import CustomSpinLoader from "../../../components/CustomSpinLoader";
import CardsChartWidget from "./charts/CardsChartWidget";
import VerticalCompareBar from "./charts/VerticalCompareBar";
import LineBarWidget from "./charts/LineBarWidget";
import TableList from "./charts/ProductionDashboard/TableList";

const DeicdeVisual = ({
  type,
  data,
  heading,
  date = null
}) => {
  switch (type) {
    case "cards_widget":
      return <CardsChartWidget data={data} heading={heading} isChart={true}/>;
    case "bars_widget":
      return <VerticalCompareBar data={data} heading={heading} size="col-8" />;
    case "hbars_widget":
      return <LineBarWidget data={data} heading={heading} size={"col-4"}/>;
    case "pie_widget":
      return <RadialWidget data={data} heading={heading} />;
    case "table_widget":
      return <TableList data={data} heading={heading} size="col-12" date={date}/>;
    case "donut_widget&category_analysis":
      return <div className="col col-6 row mx-0 mt-3 px-2 position-relative">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          <div><h5 className="mb-1 mt-0">Category Analysis</h5></div>
          {
            data?.category_analysis?.length ? (
              <DonutWidget data={data.category_analysis} isCart={false} heading="" size="col-12" />
            ) : ""
          }
          <div className="mt-2"></div>
          {
            data?.category_percent?.length ? (
              <LineBarWidget data={data.category_percent} isCart={false} heading="ca" size="col-12" />
            ) : ""
          }
        </div>
      </div>;
    case "list&discount_impact":
      return <div className="col col-6 row mx-0 mt-3 px-2 position-relative">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          <div><h5 className="mb-1 mt-0">Discount Impact</h5></div>
          <div style={{ maxHeight: "160px", overflowY: "auto", overflowX: "hidden",}} className="bill_modal_scroll card rounded mt-2 mb-1">
            <div className="table-text border border-1 border-bottom font-weight-md flex-row px-2 py-1 d-flex justify-content-between">
              <div>Gross Sales</div>
              <div>{data["Gross Sales"]}</div>
            </div>
            {
              data?.discount && data.discount.map((item)=>{
                return (
                  <div className="table-text border border-1 border-bottom font-weight-md flex-row px-2 py-1 d-flex justify-content-between">
                    <div>{item.name}</div>
                    <div>{item.value}</div>
                  </div>
                )
              })
            }
             <div className="table-text border border-1 border-bottom font-weight-md flex-row px-2 py-1 d-flex justify-content-between">
              <div>Net Sales</div>
              <div>{data["Net Sales"]}</div>
            </div>
          </div>
          {
            data.discount?.length ? (
              <DonutWidget data={data.discount} isCart={false} heading="" size="col-12" />
            ) : ""
          }
        </div>
      </div> 

    case "hbars_widget&list":
      return <div className="col col-12 row mx-0 mt-3 px-2 position-relative">
        <div className="dashboard__card col col-12 w-100 flex-basis-100">
          <div><h5 className="mb-2 mt-0">Recipe Compliance</h5></div>
          {
            data?.hbars?.length ? (
              <LineBarWidget data={data.hbars} heading="Compliance By Branch" isCart={false} size="col-12"/> 
            ) : ""
          }
          {
            data?.list?.length ? (
              <TableList data={data.list} isCart={false} heading="Top Recipe Variances" size="col-12" date={date}/>
            ) : ""
          }
        </div>
      </div> 
      
    default:
      return null;
  }
};

var authUser = "";
var authBranch = "";

const getAxiosReq = (details, params) => {
  const url = `${BASE_URL}/${details.endpoint}`;
  const formData = {};
  for (const key in params) {
    formData[key] = params[key];
  }
  if (
    (authUser?.details?.user_type === "staff" ||
      authUser?.details?.user_type === "manager") &&
    !formData.branch_id
  ) {
    formData.branch_id = authBranch?.id;
  }
  return axios
    .post(url, formData, {
      headers: { Authorization: `Bearer ${getCookie()}` },
    })
    .then((res) => res)
    .catch((err) => err);

};

const allApis = [
  {endpoint:"widgets/actual_ideal_food_costings",}, 
  {endpoint:"widgets/variance_heat_map",},
  {endpoint:"widgets/branch_wise_performance",},
  {endpoint:"widgets/category_analysis",},
  {endpoint:"widgets/discount_analysis",},
  {endpoint:"widgets/recipe_wise_compliance",},
]

const CostingDashboard = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let { loading, setLoading, dataPaginating, setDataPaginating } =
    useContext(SettingsContext);

  let { branchForSearch } = useContext(RestaurantContext);
  let { authUserInfo } = useContext(UserContext);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [branch, setBranch] = useState(null);

  const [cardData, setCardData] = useState([]);
console.log("abcd6",cardData)
  const date = {
    startDate: startDate,
    endDate: endDate,
  }
  // data fetching
  useEffect(() => {
    //setLoading(true);
    getReport(() => {
      setLoading(false);
    });
  }, []);

  //get reports
  const getReport = () => {
    handleApplyFilter();
  };

  const handleSaveResApi1 = (data) =>{
    return [{
        type: "cards_widget",
        heading: "",
        sort: 1,
        data: data.cards
      },
      {
        type: "bars_widget",
        heading: "Branch Wise Ideal Vs Actual",
        sort: 2,
        data: {
          actual: data?.actual_food_costings_details ?? [],
          // && data.actual_food_costings_details.map(item=> ({name:item.branch_name, value:item.actual_food_cost_percentage})),
          ideal: data?.ideal_food_costings_details ?? [],
          // && data.ideal_food_costings_details.map(item=>({name: item.branch_name, value: item.ideal_food_cost_percent}))
        }
      },
      {
        type: "hbars_widget",
        heading: "Variance Exception List",
        sort: 3,
        data: data?.branch_wise_variance ?? [],
        // && data.branch_wise_variance.map(item=>({name: item.branch_name, value: item.variance_percent}))
      },
      {
        type: "hbars_widget&list",
        sort: 6,
        heading: "Recipe Compliance",
        data: {
          hbars: data?.branch_wise_compliance ?? [],
        }
      },
    ]
  }

  const handleSaveResApi2 = (data) =>{
    return {
      sort: 4,
      type: "table_widget",
      heading: "Brach Wise Variance Heat Map",
      data: data
    }
  }

  const handleSaveResApi3 = (data) =>{
    return {
      sort: 5,
      type: "table_widget",
      heading: "Branch Wise Performance",
      data: data
    }
  }

  const handleSaveResApi4 = (data) =>{
    return {
      sort: 7,
      type: "donut_widget&category_analysis",
      heading: "Category Analysis",
      data: {
        category_analysis: data,
        category_percent: data?.length && data?.map(item=>({name: item.name, value: item.percentage})),
      }
    };
  }

  const handleSaveResApi5 = (data) =>{
    return {
      sort: 7,
      type: "list&discount_impact",
      heading: "Discount Impact",
      data: data
    }
  }

   const handleSaveResApi6 = (data) =>{
    return {
      type: "hbars_widget&list",
      data : data, 
    }
  }

  const handlers = [
    handleSaveResApi1,
    handleSaveResApi2,
    handleSaveResApi3,
    handleSaveResApi4,
    handleSaveResApi5,
    handleSaveResApi6
  ];

  const getAllApis = async (allApisTemp, formData = {}) => {
    setDataPaginating(true);
    const allRes = await Promise.all(
      allApisTemp.map((api) => getAxiosReq(api, formData))
    );
    setDataPaginating(false);
    const res = allRes.map((res,index)=>{
      if (res.status === 200 && handlers[index]) {
        return handlers[index](res.data);
      }
      return null;
    });
    if(res?.[0]){
      const last = res.at(-1);
      const updated = [
        ...res.slice(1, -1),
        ...res[0].map((item) =>
          item.type === last?.type
            ? {
                ...item,
                data: {
                  ...item.data,
                  list: last?.data
                }
              }
            : item
        )
      ].sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));;
      setCardData(updated);
    }
  };

  const handleBranch = (branch) => {
    setBranch(branch);
  };

  const handleApplyFilter = () => {
    const formData = {};
    const branchData = branch?.length ? branch.map((branch) => branch.id) : "";
    formData.branch_id = branchData;
    formData.fromDate = startDate ? moment(startDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    formData.toDate = endDate ? moment(endDate).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD");
    getAllApis(allApis, formData);
  };

  return (
    <>
      <Helmet>
        <title>{_t(t("Dashboard"))}</title>
      </Helmet>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-10 t-pr-10">
                    {/* Loading effect */}
                    {loading === true ? (
                      tableLoading()
                    ) : (
                      <div key="smtp-form reports-dashboard">
                        <div className="row gx-2 mx-1 align-items-center t-pt-15 pb-2">
                          <div className="col-12 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Costing Dashboard"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        {/* next page data spin loading  <div className={`${dataPaginating && "loading"}`}></div> */}

                        <CustomSpinLoader loading={loading || dataPaginating} />

                        {/* spin loading ends */}
                        <div className="row mx-1 gx-2 mt-2">
                          <div className="col-3 col-md-2 d-md-block">
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2 t-mb-15 mb-md-0"
                              placeholderText={_t(t("From date"))}
                              shouldCloseOnSelect={true}
                            />
                          </div>
                          <div className="col-3 col-md-2 t-mb-15 mb-md-0">
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2"
                              placeholderText={_t(t("To date"))}
                              shouldCloseOnSelect={true}
                            />
                          </div>
                          <Select
                            options={branchForSearch ? branchForSearch : []}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            value={branch}
                            isClearable
                            classNamePrefix="select"
                            className="xsm-text col-4"
                            onChange={handleBranch}
                            isMulti
                            styles={customStyle}
                            maxMenuHeight="180px"
                            placeholder={_t(t("Select a branch")) + ".."}
                            isDisabled={
                              authUserInfo
                                ? authUserInfo?.details?.user_type ===
                                    "staff" ||
                                  authUserInfo?.details?.user_type === "manager"
                                : false
                            }
                          />
                          <div className="d-none d-md-block col-md-2"> </div>
                          <div className="col-2 col-md-2 t-mb-15 mb-md-0 d-none d-md-block text-right">
                            <button
                              className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded "
                              onClick={handleApplyFilter}
                            >
                              {_t(t("View Dashboard"))}
                            </button>
                          </div>

                          <div className="col-2 col-md-3 t-mb-15 mb-md-0 d-block d-md-none">
                            <button
                              className="btn btn-block btn-primary text-uppercase sm-text rounded"
                              onClick={handleApplyFilter}
                            >
                              {_t(t("View Dashboard"))}
                            </button>
                          </div>
                        </div>
                        <div className="row gx-2 mt-2 mb-3">
                          {cardData
                            ? cardData.map((card) => (
                                <DeicdeVisual
                                  type={card.type}
                                  data={card.data}
                                  heading={card.heading}
                                  previous={card?.previous && card?.previous}
                                  date={date}
                                />
                              ))
                            : ""}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default CostingDashboard;
